import React, { useMemo } from 'react';
import { Wrapper } from './sort-list-user-products.styles';
import { SortListProductsProps } from './types';
import { DropdownSort } from '@shared/ui/dropdown-sort/dropdown-sort';
import { DropdownSortOption } from '@shared/ui/dropdown-sort/types';
import { DEFAULT_SORT_OPTIONS } from '@shared/ui/dropdown-sort/constants';

export const SortListProducts: React.FC<SortListProductsProps> = ({ parameters, setParameters }) => {
    const activeOption = useMemo(() => {
        const parametersOption = DEFAULT_SORT_OPTIONS.find((option) => option.value === (parameters?.sort || null));
        return parametersOption || DEFAULT_SORT_OPTIONS[1];
    }, [parameters?.sort]);

    const handleChange = (option: DropdownSortOption) => {
        if (!parameters || !setParameters) {
            return;
        }
        setParameters({ ...parameters, order: option.value && 'created_at', sort: option.value });
    };

    return (
        <Wrapper>
            <DropdownSort
                options={DEFAULT_SORT_OPTIONS}
                value={activeOption}
                menuProps={{
                    position: 'bottom-start',
                    style: { minWidth: 190 },
                }}
                onChange={handleChange}
            />
        </Wrapper>
    );
};
